import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import apiGet from '@api/api-get';
import apiPost from '@api/api-post';
import apiDelete from '@api/api-delete';
import apiPut from '@api/api-put';

interface IResult {
  code: number,
  msg: string,
  result: any,
}

const demandService = {
  // 行业招聘热度
  getIndustryHot: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/multi_industry/latest');
    if (!data) return [];
    return (data as IResult).result;
  },

  // 招聘趋势
  getIndustryTrend: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/multi_industry/trend');
    if (!data) return [];
    return (data as IResult).result;
  },

  // 招聘趋势
  getIndustryTrendYear: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/industry/amount_salary/year_trend');
    if (!data) return [];
    return (data as IResult).result;
  },
  getIndustryTrendMonth: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/industry/amount_salary/month_trend');
    if (!data) return [];
    return (data as IResult).result;
  },
  getIndustryTrendQuarter: async (params: any = {}) => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/industry/amount_salary/quarter_trend', params);
    if (!data) return [];
    return (data as IResult).result;
  },
  getCompanyTime: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/company/by_industry/date_options');
    if (!data) return [];
    return (data as IResult).result;
  },
  getCompanyIndustry: async (parmes: any) => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/company/by_industry', parmes);
    if (!data) return [];
    return (data as IResult).result;
  },
  getCompanyIndustryTime: async (parmes: any) => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/company/by_date', parmes);
    if (!data) return [];
    return (data as IResult).result;
  },
  getCompanyRankTime: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/company/top/date_options');
    if (!data) return [];
    return (data as IResult).result;
  },
  getCompanyRankList: async (parmes: any) => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/company/top', parmes);
    if (!data) return [];
    return (data as IResult).result;
  },
  getCityTimeList: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/city/date_options');
    if (!data) return [];
    return (data as IResult).result;
  },
  getCityList: async (parmes: any) => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/city', parmes);
    if (!data) return [];
    return (data as IResult).result;
  },
  getCategoryList: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/category/category_type_list');
    if (!data) return [];
    return (data as IResult).result;
  },
  getChartList: async (parmes: any) => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/recruitment/category/quarter_trend', parmes);
    if (!data) return [];
    return (data as IResult).result;
  },
  getRankTop10: async (parmes: any) => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/hot_category/top', parmes);
    if (!data) return [];
    return (data as IResult).result;
  },
  getRankTop30: async (parmes: any) => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/hot_category/detail', parmes);
    if (!data) return [];
    return (data as IResult).result;
  },
  getTimeListTop: async () => {
    const data: IResult | null =
      await apiGet('/mg/hr_indicator/hot_category/date_options');
    if (!data) return [];
    return (data as IResult).result;
  },
};

export default demandService;
